import {
  UPDATE_THEME,
  GET_ALL_STYLES,
  UPDATE_BACKGROUND,
  UPDATE_TEXT_COLOR,
  UPDATE_BUTTON,
  UPDATE_IMAGE_LINK,
  UPDATE_SHOW_FOOTER,
} from './types';

import { Styles } from './api';

export const getAllStylesAction = id => async dispatch => {
  const response = await Styles.getAllStyles(id);

  if (!response.error) {
    dispatch({ type: GET_ALL_STYLES, payload: response });
  }
  return response;
};

export const updateThemeAction = (id, param) => async dispatch => {
  const response = await Styles.updateTheme(id, param);

  if (!response.error) {
    dispatch({ type: UPDATE_THEME, payload: param.theme_id || null });
  }
  return response;
};

export const updateBackgroundAction = (id, param) => async dispatch => {
  const response = await Styles.updateBackground(id, param);

  if (!response.error) {
    dispatch({ type: UPDATE_BACKGROUND, payload: response.data });
  }
  return response;
};

export const updateTextColorAction = (id, param) => async dispatch => {
  const response = await Styles.updateTextColor(id, param);

  if (!response.error) {
    dispatch({ type: UPDATE_TEXT_COLOR, payload: response.data });
  }
  return response;
};

export const updateButtonAction = (id, param) => async dispatch => {
  const response = await Styles.updateButton(id, param);

  if (!response.error) {
    dispatch({ type: UPDATE_BUTTON, payload: response.data });
  }
  return response;
};

export const updateImageLinkAction = (id, param) => async dispatch => {
  const response = await Styles.updateImageLink(id, param);

  if (!response.error) {
    dispatch({ type: UPDATE_IMAGE_LINK, payload: response.data });
  }
  return response;
};

export const updateShowFooterAction = (id, param) => async dispatch => {
  const response = await Styles.updateShowFooter(id, param);

  if (!response.error) {
    dispatch({ type: UPDATE_SHOW_FOOTER, payload: param.footer_state });
  }
  return response;
};



// WEBPACK FOOTER //
// ./src/store/modules/styles/actions.js